module.exports = __webpack_public_path__ + "fonts/ubuntu-v14-latin-500.437d925.woff";